import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../deps';

import './BackstagePodcastDescription.scss';

const BackstagePodcastDescription = props => {
  const descriptionContentClasses = D.createBEM('BackstagePodcastDescription__content', {
    fullDescription: props.isFullDescription,
  });

  return (
    <div className='BackstagePodcastDescription'>
      {!!props.descriptionSubheader && (
        <div className='BackstagePodcastDescription__subheader'>{props.descriptionSubheader}</div>
      )}
      <div className={descriptionContentClasses}>{props.descriptionContent}</div>
    </div>
  );
};

BackstagePodcastDescription.propTypes = {
  isFullDescription: PropTypes.bool,
  descriptionSubheader: PropTypes.node,
  descriptionContent: PropTypes.node,
};

export default BackstagePodcastDescription;
